import { createFileRoute } from '@tanstack/react-router'
import NomineeRegister from '@/features/auth/nominee/NomineeRegister'

export const Route = createFileRoute('/(auth)/nominee-register')({
  component: NomineeRegister,
})
